export default `vec3 Q;
    Q=p;
    Q.xy=vec2(atan(Q.x,Q.y)/.157,length(Q.xy)-3.);
    Q.zx=fract(Q.zx)-.5;
    return min(min(length(Q.xy),length(Q.yz))-.2,p.y+.5);
  }`